import '../css/webflow.css';
import '../css/normalize.css';
import '../css/muse-5f8743.webflow.css';
import { getLoggedInUser, logUserActivity } from './utils';

window.apiHost = process.env.API_HOST;

if (localStorage.getItem('apiHost')) {
    window.apiHost = localStorage.getItem('apiHost');
    console.log(`window.apiHost override to %O`, window.apiHost);
}

captureCampaignParam();
fixupSignedInState();

function fixupSignedInState() {
    if (getLoggedInUser() != null) {
        $('.nav-items a[href="sign-up"]').text('Account');
        $('.nav-items a[href="sign-up"]').attr('href', '/account-overview');

        $('.nav-items a[href="login"]').text('Account');
        $('.nav-items a[href="login"]').attr('href', '/account-overview');
    }
}

function captureCampaignParam() {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const campaignParam = params.get('c');

    if (campaignParam) {
        // Get campaigns from local storage or initialize it
        let campaigns = JSON.parse(localStorage.getItem('campaigns')) || [];

        // Append the campaign parameter to the array
        if (!campaigns.includes(campaignParam)) {
            campaigns.push(campaignParam);
            localStorage.setItem('campaigns', JSON.stringify(campaigns));
        }

        try {
            const user = getLoggedInUser()
            if (user) {
                logUserActivity('VIEW_DESKTOP_DOWNLOAD_APP', user.urn, {user, campaign: campaignParam})
            } else {
                logUserActivity('VIEW_DESKTOP_DOWNLOAD_APP', {user, campaign: campaignParam})
            }
        } catch (error) {
            console.error('Error in Analytics:', error)
        }
    
        // Remove the `c` parameter
        params.delete('c');

        // Update the URL without the `c` parameter
        const newUrl = `${url.origin}${url.pathname}${params.toString() ? '?' + params.toString() : ''}`;
        window.history.replaceState({}, document.title, newUrl);
    }
}
